import React from "react";

function CancelApppointment({ setisopen, id }) {

  function cancel() {
    console.log(id);
    try {
        fetch(`${process.env.REACT_APP_API_URL}/appointment/cancelappointment`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 'id' : id }),
          credentials: "include",
        })
        .then((res) => res.json())
        .then((data) => alert(data.message))
        .catch((err) => console.error("Error fetching api:", err));
    } catch (error) {
      console.log("Error:", error);
    }
    setisopen(false);
    window.location.reload()
  }

  return (
    <div className="w-[100vw] h-[100vh] absolute top-0 left-0 flex justify-center items-center">
      <div className="z-20">
        <div class="fixed inset-0 w-screen overflow-y-auto ">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div class="sm:flex sm:items-start">
                  <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <h3
                      class="text-base font-semibold leading-6 text-gray-900"
                      id="modal-title"
                    >
                      Cancel Appointment
                    </h3>

                    <div class="mt-2">
                      <p class="text-sm text-gray-500">
                        Are you sure you want to Cancel The Appointment
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <button
                  type="button"
                  class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                  onClick={() => cancel()}
                >
                  Delete
                </button>
                <button
                  type="button"
                  class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  onClick={() => setisopen(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="w-[100vw] h-[100vh] bg-slate-400 opacity-90 top-0 left-0 flex justify-center items-center z-10 fixed"
        onClick={() => setisopen(false)}
      ></div>
    </div>
  );
}

export default CancelApppointment;
